<template>
    <b-tabs pills active-nav-item-class="nav-pill-warning" nav-class="bg-light p-25 mx-1 mt-1 custom-nav">
        <b-tab title="Belgeler" active>
            <employee-registry-file-documents :id="id" :code="code"></employee-registry-file-documents>
        </b-tab>
        <!-- <b-tab title="Kişisel Koruyucu Donanım">
            <employee-protective-equipment :id="id"></employee-protective-equipment>
        </b-tab> -->
    </b-tabs>
</template>

<script>
import { BTabs,BTab } from "bootstrap-vue"
import EmployeeRegistryFileDocuments from "./files/EmployeeRegistryFileDocuments.vue"
import EmployeeProtectiveEquipment from './protective-equipment/EmployeeProtectiveEquipment.vue'
export default {
    components:{
        BTabs,
        BTab,
        EmployeeRegistryFileDocuments,
        EmployeeProtectiveEquipment
    },
    props:{
        id:[String,Number],
        code:[String,null]
    }
}
</script>

<style>

</style>